import styled from '@emotion/styled';
import Button from '@mui/material/Button';

import { BREAKPOINTS, COLORS, FONT_SIZE, GLOBAL, SPACE } from '@/constants';

export const SuggestionsContainer = styled.div`
  gap: ${SPACE.X1};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  margin-top: 16px;
  margin-bottom: ${SPACE.X3};

  @media (min-width: ${BREAKPOINTS.LG}px) {
    margin-top: 32px;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }
`;

export const SuggestionCard = styled(Button)`
  &.MuiButtonBase-root {
    background-color: ${COLORS.WHITE};
    padding: ${SPACE.X1};
    color: ${COLORS.BLACK};
    text-transform: none;
    font-family: ${GLOBAL.BRAND_FONT_FAMILY};
    text-align: left;
    filter: drop-shadow(0 2px 11px ${COLORS.GREY_FOUR});
    border-radius: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: ${SPACE.X1};
    font-size: ${FONT_SIZE.SMALL};

    svg {
      width: 18px;
      height: 12px;
      flex-shrink: 0;
      align-self: flex-start;
    }

    @media (min-width: ${BREAKPOINTS.MD}px) {
      font-size: ${FONT_SIZE.MEDIUM};
    }

    @media (min-width: ${BREAKPOINTS.LG}px) {
      flex-direction: row;
      min-height: auto;

      svg {
        width: 24px;
        height: 24px;
        margin: auto 0 auto ${SPACE.X0};
      }
    }

    &:hover {
      background-color: ${COLORS.WHITE};
    }

    &.Mui-focusVisible {
      outline: 2px solid ${COLORS.BRAND_BLUE_EIGHT};
      outline-offset: 2px;
    }
  }
`;
